<template>
  <div>
    <button
      class="search-modal-reset nice-blue-background"
      @click="resetFilter"
      v-if="filterActive"
    >{{$t("search.clearOnMap")}}</button>
    <modal
      name="modal-search"
      class="modal-search"
      :draggable="isMobile() ? false : '.modal-header'"
      width="800px"
      height="auto"
    >
      <div class="modal-content" style="display: flex; max-height: 100vh;">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t("search.title") }}</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="$modal.hide('modal-search');"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-search-vuebar" style="overflow-y: scroll">
          <div>
            <table class="table">
              <thead>
                <tr>
                  <th colspan="2" class="table-head">{{ $t("search.parameteres") }}</th>
                </tr>
              </thead>
              <tbody>
                <template>
                  <tr>
                    <td>{{ $t("search.category.label") }}</td>
                    <td>
                      <multiselect
                        v-model="SearchCategorySelected"
                        :options="SearchCategoryValue"
                        :searchable="false"
                        :close-on-select="true"
                        :show-labels="false"
                        :allow-empty="false"
                        track-by="listType"
                        label="name"
                        v-bind:placeholder="this.$t('search.placeholder')"
                        open-direction="bottom"
                      ></multiselect>
                    </td>
                    <td v-if="!isPhoneLayout" class="hidden"></td>
                    <td v-if="!isPhoneLayout" class="hidden"></td>
                  </tr>
                  <tr>
                    <td>{{ $t("search.surfaceFrom") }} [ha]</td>
                    <td>
                      <input id="surfaceFrom" type="text" v-model="surfaceFrom" />
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("search.surfaceTo") }} [ha]</td>
                    <td>
                      <input id="surfaceTo" type="text" v-model="surfaceTo" />
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" class="table-head">{{ $t("search.localization") }}</td>
                  </tr>
                  <tr>
                    <td class="bg-blue">{{ $t("search.voivodeship") }}</td>
                    <td>
                      <multiselect
                        v-if="wojewodztwa"
                        v-model="wojewodztwo"
                        :options="withAllOption(wojewodztwa)"
                        :searchable="false"
                        :close-on-select="true"
                        :show-labels="false"
                        :allow-empty="false"
                        track-by="id"
                        label="nazwa"
                        v-bind:placeholder="this.$t('search.placeholder')"
                        open-direction="bottom"
                      ></multiselect>
                    </td>
                  </tr>
                  <tr>
                    <td class="bg-blue">{{ $t("search.district") }}</td>
                    <td>
                      <multiselect
                        v-if="wojewodztwo"
                        v-model="powiat"
                        :options="withAllOption(wojewodztwo.powiaty)"
                        :searchable="false"
                        :close-on-select="true"
                        :show-labels="false"
                        :allow-empty="false"
                        v-bind:placeholder="this.$t('search.placeholder')"
                        open-direction="bottom"
                        track-by="id"
                        label="nazwa"
                      ></multiselect>
                    </td>
                  </tr>
                  <tr>
                    <td class="bg-blue">{{ $t("search.community") }}</td>
                    <td>
                      <multiselect
                        v-if="powiat"
                        v-model="gmina"
                        :options="withAllOption(powiat.gminy)"
                        :searchable="false"
                        :close-on-select="true"
                        :show-labels="false"
                        :allow-empty="false"
                        v-bind:placeholder="this.$t('search.placeholder')"
                        @select="selectedCity='';"
                        track-by="id"
                        label="nazwa"
                        open-direction="bottom"
                      ></multiselect>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>

            <table class="table" v-if="isPhoneLayout">
              <thead>
              <tr>
                <th colspan="2" class="table-head">{{ $t("search.filters") }}</th>
              </tr>
              </thead>
              <tbody>
              <template>
                <tr>
                  <td>
                    <div class="checkbox-with-label">
                      <input
                              type="checkbox"
                              name="distanceFromPlaceCheckbox"
                              id="distanceFromPlaceCheckbox"
                              class="search-checkbox"
                              v-model="distanceFromPlaceCheckbox"
                      />
                      <label for="distanceFromPlaceCheckbox" class="search-checkbox-label"></label>
                      {{ $t("search.inDistance") }}
                    </div>
                  </td>
                  <td>
                    <multiselect
                            id="distanceKM_1"
                            ref="distanceKM_1"
                            v-model="SearchFiltersFromPlaceSelected"
                            :options="SearchFiltersDistanceValue"
                            :searchable="false"
                            :close-on-select="true"
                            :show-labels="false"
                            :allow-empty="false"
                            label="label"
                            trak-by="value"
                            v-bind:placeholder="this.$t('search.placeholder')"
                            open-direction="bottom"
                    ></multiselect>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("search.fromPlace") }}</td>
                  <td>
                    <!-- <input id="fromPlace" ref="fromPlace" type="text"> -->
                    <div>
                      <multiselect
                              id="fromPlace"
                              ref="fromPlace"
                              class="fromPlace"
                              v-model="selectedCity"
                              v-bind:placeholder="this.$t('search.enterCity')"
                              label="name"
                              track-by="name"
                              :options="searchCities"
                              :showNoResults="false"
                              :loading="isLoading"
                              selectLabel
                              selectedLabel
                              deselectLabel
                              @search-change="getCities"
                              @open="innerHtlmMulitSelect"
                      ></multiselect>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="checkbox-with-label">
                      <input
                              type="checkbox"
                              name="distanceFromPointCheckbox"
                              id="distanceFromPointCheckbox"
                              v-model="distanceFromPointCheckbox"
                              class="search-checkbox"
                      />
                      <label for="distanceFromPointCheckbox" class="search-checkbox-label"></label>
                      {{ $t("search.inDistance") }}
                    </div>
                  </td>
                  <td>
                    <multiselect
                            id="distanceKM_2"
                            ref="distanceKM_2"
                            v-model="SearchFiltersFromPointSelected"
                            :options="SearchFiltersDistanceValue"
                            :searchable="false"
                            :close-on-select="true"
                            :show-labels="false"
                            :allow-empty="false"
                            label="label"
                            trak-by="value"
                            v-bind:placeholder="this.$t('search.placeholder')"
                            open-direction="bottom"
                    ></multiselect>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("search.fromPoint") }}</td>
                  <td>
                    <div v-if="coordinates">
                      <div style="width:50%;float:left">
                        <div v-text="coordinates[0].toFixed(4)"></div>
                        <div v-text="coordinates[1].toFixed(4)"></div>
                      </div>
                      <div style="width:50%;float:right">
                        <b-button
                                size="sm"
                                variant="link"
                                class="search-set-point"
                                @click="coordinates = undefined;distanceFromPointCheckbox = false"
                        >{{ $t("search.clear") }}</b-button>
                      </div>
                    </div>
                    <b-button
                            size="sm"
                            variant="link"
                            class="search-set-point"
                            @click="setFilter();"
                            v-else
                    >{{ $t("search.select") }}</b-button>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="table-head">{{ $t("search.criteria") }}</td>
                </tr>
                <tr>
                  <td>{{ $t("search.enterpriseSize.label") }}</td>
                  <td>
                    <multiselect
                            v-model="SearchEnterpriseSizeSelected"
                            :options="SearchEnterpriseSizeValue"
                            :searchable="false"
                            :close-on-select="true"
                            :show-labels="false"
                            :allow-empty="false"
                            label="name"
                            v-bind:placeholder="this.$t('search.placeholder')"
                            open-direction="top"
                    ></multiselect>
                  </td>
                </tr>
                <tr>
                  <td class="bg-blue">{{ $t("search.plannedCapital") }}</td>
                  <td>
                    <input type="number" v-model="effort" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-blue">{{ $t("search.currency") }}</td>
                  <td>
                    <multiselect
                            v-model="SearchPMCESelectedSecond"
                            :options="SearchPMCEValueSecond"
                            :searchable="false"
                            :close-on-select="true"
                            :show-labels="false"
                            :allow-empty="false"
                            v-bind:placeholder="this.$t('search.placeholder')"
                            open-direction="top"
                    ></multiselect>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("search.newInvest.label") }}</td>
                  <td>
                    <multiselect
                            data-name="SearchNewInvest"
                            v-model="SearchNewInvestSelected"
                            :options="SearchNewInvestValue"
                            :searchable="false"
                            :close-on-select="true"
                            :show-labels="false"
                            :allow-empty="false"
                            v-bind:placeholder="this.$t('search.placeholder')"
                            open-direction="top"
                    ></multiselect>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
            <table class="table" v-else>
              <thead>
                <tr>
                  <th colspan="4" class="table-head">{{ $t("search.filters") }}</th>
                </tr>
              </thead>
              <tbody>
                <template>
                  <tr>
                    <td>
                      <div class="checkbox-with-label">
                        <input
                          type="checkbox"
                          name="distanceFromPlaceCheckbox"
                          id="distanceFromPlaceCheckbox"
                          class="search-checkbox"
                          v-model="distanceFromPlaceCheckbox"
                        />
                        <label for="distanceFromPlaceCheckbox" class="search-checkbox-label"></label>
                        {{ $t("search.inDistance") }}
                      </div>
                    </td>
                    <td>
                      <multiselect
                        id="distanceKM_1"
                        ref="distanceKM_1"
                        v-model="SearchFiltersFromPlaceSelected"
                        :options="SearchFiltersDistanceValue"
                        :searchable="false"
                        :close-on-select="true"
                        :show-labels="false"
                        :allow-empty="false"
                        label="label"
                        trak-by="value"
                        v-bind:placeholder="this.$t('search.placeholder')"
                        open-direction="bottom"
                      ></multiselect>
                    </td>
                    <td>{{ $t("search.fromPlace") }}</td>
                    <td>
                      <!-- <input id="fromPlace" ref="fromPlace" type="text"> -->
                      <div>
                        <multiselect
                          id="fromPlace"
                          ref="fromPlace"
                          class="fromPlace"
                          v-model="selectedCity"
                          v-bind:placeholder="this.$t('search.enterCity')"
                          label="name"
                          track-by="name"
                          :options="searchCities"
                          :showNoResults="false"
                          :loading="isLoading"
                          selectLabel
                          selectedLabel
                          deselectLabel
                          @search-change="getCities"
                          @open="innerHtlmMulitSelect"
                        ></multiselect>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="checkbox-with-label">
                        <input
                          type="checkbox"
                          name="distanceFromPointCheckbox"
                          id="distanceFromPointCheckbox"
                          v-model="distanceFromPointCheckbox"
                          class="search-checkbox"
                        />
                        <label for="distanceFromPointCheckbox" class="search-checkbox-label"></label>
                        {{ $t("search.inDistance") }}
                      </div>
                    </td>
                    <td>
                      <multiselect
                        id="distanceKM_2"
                        ref="distanceKM_2"
                        v-model="SearchFiltersFromPointSelected"
                        :options="SearchFiltersDistanceValue"
                        :searchable="false"
                        :close-on-select="true"
                        :show-labels="false"
                        :allow-empty="false"
                        label="label"
                        trak-by="value"
                        v-bind:placeholder="this.$t('search.placeholder')"
                        open-direction="bottom"
                      ></multiselect>
                    </td>
                    <td>{{ $t("search.fromPoint") }}</td>
                    <td>
                      <div v-if="coordinates">
                        <div style="width:50%;float:left">
                          <div v-text="coordinates[0].toFixed(4)"></div>
                          <div v-text="coordinates[1].toFixed(4)"></div>
                        </div>
                        <div style="width:50%;float:right">
                          <b-button
                            size="sm"
                            variant="link"
                            class="search-set-point"
                            @click="coordinates = undefined;distanceFromPointCheckbox = false"
                          >{{ $t("search.clear") }}</b-button>
                        </div>
                      </div>
                      <b-button
                        size="sm"
                        variant="link"
                        class="search-set-point"
                        @click="setFilter();"
                        v-else
                      >{{ $t("search.select") }}</b-button>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4" class="table-head">{{ $t("search.criteria") }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t("search.enterpriseSize.label") }}</td>
                    <td>
                      <multiselect
                        v-model="SearchEnterpriseSizeSelected"
                        :options="SearchEnterpriseSizeValue"
                        :searchable="false"
                        :close-on-select="true"
                        :show-labels="false"
                        :allow-empty="false"
                        label="name"
                        v-bind:placeholder="this.$t('search.placeholder')"
                        open-direction="top"
                      ></multiselect>
                    </td>
                  </tr>
                  <tr>
                    <td class="bg-blue">{{ $t("search.plannedCapital") }}</td>
                    <td>
                      <input type="number" v-model="effort" />
                    </td>
                    <td class="bg-blue">{{ $t("search.currency") }}</td>
                    <td>
                      <multiselect
                        v-model="SearchPMCESelectedSecond"
                        :options="SearchPMCEValueSecond"
                        :searchable="false"
                        :close-on-select="true"
                        :show-labels="false"
                        :allow-empty="false"
                        v-bind:placeholder="this.$t('search.placeholder')"
                        open-direction="top"
                      ></multiselect>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("search.newInvest.label") }}</td>
                    <td>
                      <multiselect
                        data-name="SearchNewInvest"
                        v-model="SearchNewInvestSelected"
                        :options="SearchNewInvestValue"
                        :searchable="false"
                        :close-on-select="true"
                        :show-labels="false"
                        :allow-empty="false"
                        v-bind:placeholder="this.$t('search.placeholder')"
                        open-direction="top"
                      ></multiselect>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="search-button">
          <b-button variant="success" @click="searchOffers();">{{ $t("search.btn") }}</b-button>
          <b-button
            variant="error"
            @click="resetFilter();"
            style="margin-left: 10px"
            v-if="filterActive"
          >{{ $t("search.clear") }}</b-button>
        </div>
      </div>
    </modal>
    <modal
      class="modal-search"
      name="modal-search-after"
      :draggable="isMobile() ? false : '.modal-header'"
      width="450px"
      height="auto"
    >
      <div class="modal-content">
        <div class="modal-body modal-search-after-bigger-text">
          <div>{{$t("search.modalAfter.text1")}}</div>
          <div>{{$t("search.modalAfter.text2")}}</div>
          <div>{{$t("search.modalAfter.text3")}}</div>
          <b-button
            class="modal-search-after-ok"
            variant="success"
            @click="$modal.hide('modal-search-after');"
          >{{ $t("search.modalAfter.ok") }}</b-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<style lang="scss">
.search-modal-reset {
  $width: 200px;
  $height: 40px;

  border: none;

  position: fixed;
  bottom: 20px;
  left: 50vw;
  right: 10px;
  width: $width;
  height: $height;
  border-radius: $height/2;
  color: white;
  cursor: pointer;
}

.search-modal-reset:focus,
.search-modal-reset:hover {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.6);
}

.modal-search-after-bigger-text {
  font-size: 1.25em;
  text-align: center;
}

.modal-search-after-ok {
  margin-top: 30px;
}

.modal-search .modal-content > *{
  padding: 1rem;
}
</style>

<script>
import Multiselect from "vue-multiselect";
import { transform } from "ol/proj.js";
import { getFilter } from '../../search';

function distanceValue(value) {
  return {
    label: `${value} km`,
    value: value
  };
}

function computedJst(name) {
  return {
    get() {
      return this[name];
    },
    set(jst) {
      if (jst.id) {
        this[name] = jst;
      } else {
        this[name] = undefined;
      }
    }
  };
}

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      isLoading: false,
      searchFilter: {
        layer: undefined,
        features: []
      },
      SearchCategorySelectedValue: "tereny",
      surfaceFrom: "",
      surfaceTo: "",
      wojewodztwo_: undefined,
      powiat_: undefined,
      gmina_: undefined,

      distanceFromPlaceCheckbox: false,
      SearchFiltersFromPlaceSelectedValue: undefined,
      selectedCity: "",
      searchCities: [],

      distanceFromPointCheckbox: false,
      SearchFiltersFromPointSelectedValue: undefined,
      coordinates: undefined,
      SearchEnterpriseSizeSelectedValue: "duze",
      effort: 0,
      SearchPMCESelectedSecond: "PLN",
      SearchPMCEValueSecond: ["PLN", "EUR", "USD"],
      SearchNewInvestSelected: this.$t("search.newInvest.selected"),
    };
  },
  computed: {
    isPhoneLayout() {
      return this.$parent.isPhoneLayout;
    },
    filterActive() {
      return this.$store.getters["search/active"];
    },
    wojewodztwo: computedJst("wojewodztwo_"),
    powiat: computedJst("powiat_"),
    gmina: computedJst("gmina_"),
    SearchCategoryValue() {
      return [
        {
          name: this.$t("search.category.value1"),
          layer: "invest_areas",
          listType: "tereny"
        },
        {
          name: this.$t("search.category.value2"),
          layer: "industrial_hall",
          listType: "hale"
        },
        {
          name: this.$t("search.category.value3"),
          layer: "offices",
          listType: "biura"
        }
      ];
    },
    SearchCategorySelected: {
      set(v) {
        this.SearchCategorySelectedValue = v.listType;
      },
      get() {
        let value = this.SearchCategorySelectedValue;
        return this.SearchCategoryValue.find(v => v.listType == value);
      }
    },
    SearchFiltersDistanceValue() {
      return [
        distanceValue(5),
        distanceValue(10),
        distanceValue(15),
        distanceValue(25),
        distanceValue(50),
        distanceValue(100),
        {
          label: this.$t("search.over"),
          value: ">100"
        }
      ];
    },
    SearchFiltersFromPlaceSelected: {
      set(v) {
        this.SearchFiltersFromPlaceSelectedValue = v.value;
      },
      get() {
        let value = this.SearchFiltersFromPlaceSelectedValue;
        return this.SearchFiltersDistanceValue.find(v => v.value == value);
      }
    },
    SearchFiltersFromPointSelected: {
      set(v) {
        this.SearchFiltersFromPointSelectedValue = v.value;
      },
      get() {
        let value = this.SearchFiltersFromPointSelectedValue;
        return this.SearchFiltersDistanceValue.find(v => v.value == value);
      }
    },
    SearchEnterpriseSizeValue() {
      return [
        { name: this.$t("search.enterpriseSize.value1"), value: "duze" },
        { name: this.$t("search.enterpriseSize.value2"), value: "srednie" },
        { name: this.$t("search.enterpriseSize.value3"), value: "male" },
        { name: this.$t("search.enterpriseSize.value4"), value: "mikro" }
      ];
    },
    SearchEnterpriseSizeSelected: {
      set(v) {
        this.SearchEnterpriseSizeSelectedValue = v.value;
      },
      get() {
        let value = this.SearchEnterpriseSizeSelectedValue;
        return this.SearchEnterpriseSizeValue.find(v => v.value == value);
      }
    },
    SearchNewInvestValue() {
      return [
        this.$t("search.newInvest.value1"),
        this.$t("search.newInvest.value2"),
        this.$t("search.newInvest.value3"),
        this.$t("search.newInvest.value4"),
        this.$t("search.newInvest.value5"),
        this.$t("search.newInvest.value6"),
        this.$t("search.newInvest.value7"),
        this.$t("search.newInvest.value8"),
        this.$t("search.newInvest.value9"),
        this.$t("search.newInvest.value10"),
        this.$t("search.newInvest.value11"),
        this.$t("search.newInvest.value12"),
        this.$t("search.newInvest.value13"),
        this.$t("search.newInvest.value14")
      ];
    },
    filter0() {
      let jst = this.gmina || this.powiat || this.wojewodztwo;
      return {
        listType: this.SearchCategorySelected.listType,
        minPowierzch: parseFloat(this.surfaceFrom) || undefined,
        maxPowierzch: parseFloat(this.surfaceTo) || undefined,
        jst: jst && {
          id: jst.id,
          typ_jst: jst.typ_jst
        },
        filterDistanceFromPlace:
          (this.distanceFromPlaceCheckbox &&
            this.SearchFiltersFromPlaceSelectedValue &&
            this.selectedCity && {
              km: this.SearchFiltersFromPlaceSelectedValue,
              coordinates: this.selectedCity.coordinates
            }) ||
          undefined,
        filterDistanceFromPoint:
          (this.distanceFromPointCheckbox &&
            this.SearchFiltersFromPointSelectedValue &&
            this.coordinates && {
              km: this.SearchFiltersFromPointSelectedValue,
              coordinates: this.coordinates
            }) ||
          undefined
      };
    },
    wojewodztwa() {
      return this.$store.getters["jst/wojewodztwa"];
    },
    allOption() {
      return {
        id: false,
        nazwa: this.$t("search.all")
      };
    }
  },
  methods: {
    withAllOption(options) {
      return [this.allOption, ...options];
    },
    beforeOpen() {},
    setFilter() {
      this.$modal.hide("modal-search");
      document.getElementById("map").style.cursor = "crosshair";

      this.$parent.map.once("singleclick", e => {
        this.coordinates = new transform(
          e.coordinate,
          "EPSG:3857",
          "EPSG:4326"
        );
        this.distanceFromPointCheckbox = true;
        this.$modal.show("modal-search");
        document.getElementById("map").style.cursor = "default";
      });
    },
    resetData() {
      this.SearchCategorySelectedValue = "tereny";
      this.surfaceFrom = "";
      this.surfaceTo = "";
      this.wojewodztwo_ = undefined;
      this.powiat_ = undefined;
      this.gmina_ = undefined;

      this.distanceFromPlaceCheckbox = false;
      this.SearchFiltersFromPlaceSelectedValue = undefined;
      this.selectedCity = "";
      this.searchCities = [];

      this.distanceFromPointCheckbox = false;
      this.SearchFiltersFromPointSelectedValue = undefined;
      this.coordinates = undefined;
      this.SearchEnterpriseSizeSelectedValue = "duze";
      this.effort = 0;
      this.SearchPMCESelectedSecond = "PLN";
      this.SearchPMCEValueSecond = ["PLN", "EUR", "USD"];
      this.SearchNewInvestSelected = this.$t("search.newInvest.selected");
    },
    resetFilter() {
      this.resetData();
      // this.$parent.$parent.$refs.map.resetFilter();
      this.$store.commit("search/clearFilter");
    },
    searchOffers() {
      let filter0 = this.filter0;
      let wielkosc_przedsiebiorstwa = this.SearchEnterpriseSizeSelectedValue;
      let naklady = parseFloat(this.effort) || undefined;
      let waluta = this.SearchPMCESelectedSecond;
      if (naklady) {
        getFilter({
          filter: filter0,
          waluta,
          naklady,
          wielkosc_przedsiebiorstwa,
        }).then(filter => {
          this.runFilter(filter);
        });
      } else {
        this.runFilter(filter0);
      }
    },
    runFilter(filter) {
      let mapVue = window.mapVue;
      let array = mapVue.$store.getters[`${filter.listType}/filter`](filter);
      if (array.length === 0) {
        alert("Nie znaleziono obiektów spełniających kryteria");
      } else {
        this.$store.commit("search/setFilter", filter);
        this.$modal.hide("modal-search");
        this.$modal.show("modal-search-after");
      }
    },
    innerHtlmMulitSelect() {
      Array.from(document.getElementsByClassName("multiselect__option"))
        .filter(e => e.innerHTML == "List is empty.")
        .forEach(e => (e.innerHTML = "Lista jest pusta."));
    },
    async getCities(query) {
      if (!query) {
        this.searchCities = [];
        return;
      }
      this.isLoading = true;
      await this.$http
        .get("https://secure.geonames.org/searchJSON", {
          params: {
            formatted: "true",
            q: query,
            maxRows: "10",
            lang: "pl",
            username: "wsse3",
            style: "full",
            countryCode: "PL",
            featureClass: "P" // city, village, ...
          }
        })
        .then(response => {
          this.searchCities = response.data.geonames.map(item => ({
            name: item.name,
            coordinates: [parseFloat(item.lng), parseFloat(item.lat)]
          }));
          this.isLoading = false;
        });
    }
  }
};
</script>
